import {useNavigate, useSearchParams} from "react-router-dom";
import {useRpcSender} from "../../../RpcSender";
import {useState} from "react";
import {RpcState} from "../../../util/RpcState";
import {BookClassRequest, BookClassResponse, IBookClassRequest, IBookClassResponse} from "../../../compiled";

/**
 * When buying a single class pack or a new class package the user goes to
 * stripe to handle payment, then is redirected to the confirmation page.
 */
export const useBookClassRpc = () => {

  const navigate = useNavigate();
  const rpcSender = useRpcSender();

  const [rpcState, setRpcState] = useState<RpcState>({state: 'none'});
  const [response, setResponse] = useState<IBookClassResponse>();

  const [searchParams] = useSearchParams();
  const isPreview = searchParams.get('v') === 'DRAFT'

  const send = (request: IBookClassRequest) => {

    if (isPreview) {
      setRpcState({state: 'error', message: 'Booking is disabled in preview mode.'});
      return;
    }

    setRpcState({state: 'pending'});
    rpcSender.send('book_class', BookClassRequest.encode(request).finish())
        .then(r => {
          let response = BookClassResponse.decode(r);
          console.log('response', JSON.stringify(response.toJSON()));
          if (response.okay && response.newBooking) {
            setRpcState({state: 'success'})
            setResponse(response);
            navigate('/confirmation?b=' + response.newBooking.bookingId)

          } else {
            setRpcState({state: 'error', message: response.error});
            setResponse(response);
          }
        })
        .catch(e => {
          setRpcState({state: 'error', message: 'Network error booking class!'});
        });
  }
  
  return {
    send: send,
    rpcState: rpcState,
    response: response,
  }
}
